<template>
	<sg-modal v-model="isOpen" title="Invite QR Code">
		<div class="flex flex-col items-center gap-6 p-4">
			<div class="text-center">
				<h3 class="text-lg font-medium text-gray-500">Signup Link</h3>
				<p class="mt-1 text-2xl font-semibold text-gray-900">
					{{ username }}
				</p>
			</div>

			<q-r-code :url="inviteUrl" />

			<p class="text-center text-sm text-gray-500">
				Scan this QR code to open the signup link
			</p>
		</div>

		<template #footer>
			<div class="flex justify-end">
				<ion-button @click="isOpen = false"> Close </ion-button>
			</div>
		</template>
	</sg-modal>
</template>

<script setup lang="ts">
	import { IonButton } from "@ionic/vue";
	import SgModal from "@/components/ui/modals/SgModal.vue";
	import QRCode from "@/components/ui/QRCode.vue";

	const isOpen = defineModel<boolean>();

	defineProps<{
		username: string;
		inviteUrl: string;
	}>();
</script>
